import { render, staticRenderFns } from "./UBadge.vue?vue&type=template&id=1174af06&"
import script from "./UBadge.vue?vue&type=script&lang=js&"
export * from "./UBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports